export default "__VITE_ASSET__Bjd2_ayK__"